<div class="sick-note-modal">
  <!-- Header Section -->
  <div class="modal-header-section">
    <div class="header-content">
      <div class="header-eyebrow">Medical Documentation</div>
      <h2 class="header-title"><i class="bi bi-file-earmark-medical me-2"></i>Patient Sick Note</h2>
      <p class="header-description">
        Generate an official medical sick note for the patient. This action can only be completed
        once per appointment.
      </p>
    </div>
  </div>

  <!-- Form Content -->
  <div class="modal-body-section">
    <form [formGroup]="sickNoteForm">
      <!-- Notes Section -->
      <div class="form-section">
        <label for="notes" class="form-label-modern">
          <i class="bi bi-chat-dots me-2"></i>Medical Notes
        </label>
        <p class="form-hint">
          Provide clinical details and recommendations for the patient's sick leave
        </p>
        <textarea
          formControlName="notes"
          class="form-control-modern"
          id="notes"
          rows="4"
          placeholder="Enter medical notes and observations..."
        ></textarea>
      </div>

      <!-- Date Range Section -->
      <div class="date-range-section">
        <div class="date-field">
          <label for="startDate" class="form-label-modern">
            <i class="bi bi-calendar-event me-2"></i>Start Date
          </label>
          <p class="form-hint">When the sick leave begins</p>
          <div class="date-input-wrapper">
            <input
              class="form-control-modern date-input"
              formControlName="startDate"
              placeholder="Select start date"
              name="startDate"
              ngbDatepicker
              [minDate]="today"
              [maxDate]="futureDate"
              #startDate="ngbDatepicker"
            />
            <button
              class="date-picker-btn"
              (click)="startDate.toggle()"
              type="button"
              title="Open calendar"
            >
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>

        <div class="date-field">
          <label for="endDate" class="form-label-modern">
            <i class="bi bi-calendar-check me-2"></i>End Date
          </label>
          <p class="form-hint">When the sick leave ends</p>
          <div class="date-input-wrapper">
            <input
              class="form-control-modern date-input"
              formControlName="endDate"
              placeholder="Select end date"
              name="endDate"
              [minDate]="today"
              [maxDate]="futureDate"
              ngbDatepicker
              #endDate="ngbDatepicker"
            />
            <button
              class="date-picker-btn"
              (click)="endDate.toggle()"
              type="button"
              title="Open calendar"
            >
              <i class="bi bi-calendar3"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Actions Section -->
  <div class="modal-actions-section">
    <button
      class="btn btn-primary-modern"
      [disabled]="!sickNoteForm.valid"
      (click)="saveSickNote()"
      title="Generate and download sick note"
    >
      <i class="bi bi-download me-2"></i>Generate & Download
    </button>
    <button class="btn btn-secondary-modern" (click)="cancel()" title="Close without saving">
      <i class="bi bi-x-lg me-2"></i>Cancel
    </button>
  </div>
</div>
